import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import * as pubsub from "pubsub-js"

@Component({
  selector: 'app-modals',
  templateUrl: './modals.component.html',
  styleUrls: ['./modals.component.scss']
})
export class ModalsComponent {

  modalRef!: NgbModalRef;
  titleMsg: string = "" 
  title: string = ""
  showIcon: boolean = false
  showXIcon: boolean = true
  icon: string = "error"
  buttonOptions: any[] = [] 
  translations: any = {}
  titleStyle: string = ""

  closeModal() {
    pubsub.publish("closeGenericModal")
    this.modalRef.close()
  }

  emitEvent(eventName: string) {
    pubsub.publish(eventName, this.modalRef)
  }
}
